export const SUBJECTS = ['Math', 'Reading', 'Science', 'History', 'Language'];

export const WORKING_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
